import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { p13nSelector } from 'selectors/p13n/p13nSelector';
import { sendCmsComponentEvent } from 'analytics/utils/cmsComponents';
import { buildTrendingOffersSotFields } from 'analytics/utils/trendingOfferTracking';
import p13nUtils from 'utils/localStorage/P13n';
import constants from 'constants/content';
import anaConsts from 'analytics/constants';

const {
    BANNER_TYPES: { PERSISTENT }
} = constants;

const {
    CMS_COMPONENT_EVENTS: { IMPRESSION, ITEM_CLICK }
} = anaConsts;

const { wrapHOC } = FrameworkUtils;
const { getPersonalizationCache } = p13nUtils;

const getClientRequestId = personalization => {
    const cachedData = getPersonalizationCache(personalization?.context);

    return cachedData?.p13n?.client_request_id || null;
};

const functions = (dispatch, ownProps) => ({
    triggerImpression: function () {
        const { data } = ownProps;

        if (data && data.length > 0) {
            const firstBanner = data[0];
            const personalization = firstBanner.personalization;
            const trendingOffersSotFields = buildTrendingOffersSotFields(personalization);
            const clientRequestId = getClientRequestId(personalization);

            const eventName = IMPRESSION;
            const timestamp = personalization?.timestamp;

            sendCmsComponentEvent({
                items: [{ ...firstBanner, ...(clientRequestId && { clientRequestId }), ...(timestamp && { timestamp }) }],
                eventName,
                sid: '',
                component: PERSISTENT,
                ignoreCMSAnalyticsFlag: true,
                ...(trendingOffersSotFields && { nbcTrackingData: trendingOffersSotFields })
            });
        }
    },
    triggerClick: async function (banner) {
        const { sid: clickedSid } = banner;
        const { data } = ownProps;

        if (data && data.length > 0) {
            const eventName = ITEM_CLICK;
            const firstItem = data[0];
            const personalization = firstItem?.personalization;
            const trendingOffersSotFields = buildTrendingOffersSotFields(personalization);
            const clientRequestId = getClientRequestId(personalization);
            const timestamp = personalization?.timestamp;

            const items = data.map(item => ({ ...item, ...(clientRequestId && { clientRequestId }), ...(timestamp && { timestamp }) }));

            await sendCmsComponentEvent({
                items,
                eventName,
                sid: '',
                clickedSid,
                component: PERSISTENT,
                ignoreCMSAnalyticsFlag: true,
                ...(trendingOffersSotFields && { nbcTrackingData: trendingOffersSotFields })
            });
        }
    }
});

const connectedPersistentBanner = connect(
    createStructuredSelector({
        p13n: p13nSelector
    }),
    functions
);

const withPersistentBannerProps = wrapHOC(connectedPersistentBanner);

export {
    functions, withPersistentBannerProps
};
